import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  MenuItem,
  TextField,
} from '@mui/material';

const defaultTimezone =
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';

const dayOptions = Array.from({ length: 31 }, (_, index) => index + 1);

const toFormState = (groupCall = {}) => ({
  title: groupCall.title || '',
  desc: groupCall.desc || '',
  dayOfMonth: groupCall.dayOfMonth || 1,
  startTime: groupCall.startTime || '09:00',
  endTime: groupCall.endTime || '10:00',
  timezone: groupCall.timezone || defaultTimezone,
  meetingUrl: groupCall.meetingUrl || '',
});

export default function GroupCallForm({
  groupCall,
  onCancel,
  onSubmit,
  saving,
  submitLabel = 'Save',
}) {
  const [form, setForm] = useState(toFormState(groupCall));

  useEffect(() => {
    setForm(toFormState(groupCall));
  }, [groupCall]);

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    onSubmit({
      title: form.title,
      desc: form.desc,
      recurrence: 'MONTHLY',
      dayOfMonth: Number(form.dayOfMonth),
      startTime: form.startTime,
      endTime: form.endTime,
      timezone: form.timezone,
      meetingUrl: form.meetingUrl || null,
      access: 'PRO',
    });
  };

  return (
    <Card>
      <CardContent>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Title"
                name="title"
                onChange={handleChange}
                required
                value={form.title}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                multiline
                name="desc"
                onChange={handleChange}
                rows={4}
                value={form.desc}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Day of month"
                name="dayOfMonth"
                onChange={handleChange}
                required
                select
                value={form.dayOfMonth}
                variant="outlined"
              >
                {dayOptions.map((day) => (
                  <MenuItem key={day} value={day}>
                    {day}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Timezone"
                name="timezone"
                onChange={handleChange}
                required
                value={form.timezone}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                label="Start time"
                name="startTime"
                onChange={handleChange}
                required
                type="time"
                value={form.startTime}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                label="End time"
                name="endTime"
                onChange={handleChange}
                required
                type="time"
                value={form.endTime}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Meeting URL"
                name="meetingUrl"
                onChange={handleChange}
                helperText="Paste a reusable recurring Zoom or Google Meet link. For Google Meet, create a recurring monthly Google Calendar event, add Google Meet, copy the Meet link, and paste it here. Members will receive updates through their subscribed Tempo calendar feed."
                value={form.meetingUrl}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Box display="flex" gap={2} mt={3}>
            <Button
              color="secondary"
              disabled={saving}
              type="submit"
              variant="contained"
            >
              {submitLabel}
            </Button>
            <Button disabled={saving} onClick={onCancel} variant="outlined">
              Cancel
            </Button>
          </Box>
        </form>
      </CardContent>
    </Card>
  );
}
